<template>
  <div
    :class="$style.container"
    v-if="playerData && playerData.inventory && playerData.inventory.spirit_bear"
  >
    <div :class="$style.portrait"></div>
    <div :class="$style.inventory">
      <div :class="$style.main_inventory">
        <div :class="$style.main">
          <template v-for="(item, index) in playerData.inventory.spirit_bear.main">
            <div
              :class="[$style.item, { [$style.empty]: item.name === 'empty' }]"
              :key="`main-item-${index}`"
            >
              <div :class="$style.imgBox">
                <img :class="$style.img" :src="itemDetails(item.name)" />
              </div>
              <item-tooltip :item="item.name" :level="item.level" position="bottom" :delay="300" />
            </div>
          </template>
        </div>
      </div>
      <div :class="$style.backpack">
        <div
          v-for="(item, index) in playerData.inventory.spirit_bear.backpack"
          :class="[$style.item, { [$style.empty]: item.name === 'empty' }]"
          :key="`backpack-item-${index}`"
        >
          <div :class="$style.imgBox">
            <img :class="$style.img" :src="itemDetails(item.name)" />
          </div>
          <item-tooltip :item="item.name" :level="item.level" position="bottom" :delay="300" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemTooltip from '../tooltips/item-tooltip.vue'

export default {
  name: 'hero-spirit-bear',
  components: { ItemTooltip },
  computed: {
    playerData() {
      return this.$store.getters.playerData
    }
  },
  methods: {
    itemDetails(item) {
      return this.getItemDetails(item, 'image')
    }
  }
}
</script>

<style lang="scss" module>
.container {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 0.6vw;
  bottom: calc(-100% + 1.5vw);
  left: 47%;
  padding: 0.2vw 0.4vw;
  border-radius: 0.2vw;
  border: 0.2vw solid rgba(var(--color_black-rgb), 0.5);
  background: rgba(#162024, 0.95);
  box-shadow: 0 0.05vw 0.2vw rgba(var(--color_black-rgb), 0.5);
}

.portrait {
  overflow: hidden;
  border-radius: 50%;
  width: 4.5vw;
  height: 4.5vw;
  background: url('~@/assets/imgs/spirit_bear.png') center center no-repeat;
  background-size: cover;
  border: 0.1vw solid black;
  box-shadow: inset rgba(black, 0.8) 0 0 0.8vw;
}

.item {
  position: relative;
  border-radius: 0.2vw;
  cursor: pointer;

  &:hover:not(.empty) {
    box-shadow: 0 0 0.2vw var(--color_primary);
  }

  .imgBox {
    border: 0.1vw solid black;
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 0.2vw;
    overflow: hidden;
    box-shadow: inset rgba(black, 0.8) 0 0 0.8vw;
  }

  .img {
    height: calc(100% + 0.1vw);
    position: absolute;
    top: -0.05vw;
    left: 50%;
    transform: translateX(-50%);
  }

  &.empty {
    cursor: default;

    .img {
      display: none;
    }
  }
}

.inventory {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main_inventory {
  display: flex;
  align-items: center;
  gap: 0.2vw;
}

.main {
  height: auto;
  display: flex;
  flex-wrap: wrap;
  width: 8.6vw;
  gap: 0.2vw;

  .item {
    height: 2vw;
    width: 2.7vw;
  }
}

.backpack {
  height: auto;
  width: 100%;
  display: flex;
  gap: 0.4vw;
  margin-top: 0.3vw;
  justify-content: center;
  align-self: flex-start;

  .item {
    height: 1.5vw;
    width: 2.1vw;
  }

  .imgBox {
    background: rgba(black, 0.3);
  }

  .img {
    filter: grayscale(1);
  }
}
</style>
